'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function consent(properties) {
    return {
        id: 'userConsents',
        component: 'magic-sign-up-consents',
        isDataField: true,
        isStandAlone: true,
        properties: {
            'collapsible-marketing-preferences': properties.collapsibleMarketingPreferences,
        },
    };
}

exports.consent = consent;
